"use client";

import XTwitter from "@/assets/svg-icons/twitter";
import { Button } from "@/components/ui/borded-button";
import { cn } from "@/lib/utils";
import Link from "next/link";
import React from "react";

export interface GifArtCardProps {
  image: string;
  link?: string;
}

const GifArtCard = ({ image, link }: GifArtCardProps) => {
  return (
    <div className="flex w-full flex-col">
      <div className="relative h-auto max-h-[340px] overflow-hidden rounded-[12px] border border-border/50 p-2">
        {link && (
          <Link
            href={link}
            target="_blank"
            className="absolute bottom-4 right-4 z-10 text-xs text-muted-foreground"
          >
            <Button
              buttonStyle="borded"
              className="h-5 gap-1 px-1.5 text-[10px] hover:text-brand [&_svg]:size-3"
            >
              <XTwitter />
              <span>View</span>
            </Button>
          </Link>
        )}

        <video
          className={cn("h-auto w-full rounded-[8px] transition-opacity duration-300")}
          src={image}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          controls={false}
          webkit-playsinline="true"
        />
      </div>
    </div>
  );
};

export default GifArtCard;
